import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { DeriveTransformation } from 'app/model/dataflow/derivetransformation';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { ExpressionBasedColumnVisitorAdapterUtils } from '../expression-based-column-visitor-adapter.utils';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DeriveTransformation),
    asynchronous: true
})
export class DeriveTransformationAdapter extends TransformationAdapter<DeriveTransformation> {
    public async getDslScript(deriveTransformation: DeriveTransformation): Promise<string> {
        const columnConditions = await ExpressionBasedColumnVisitorAdapterUtils.writeToDsl(
            this.context.contextData,
            deriveTransformation.expressionColumns,
            deriveTransformation
        );
        const transientAssignments = await ExpressionBasedColumnVisitorAdapterUtils.writeToDsl(
            this.context.contextData,
            deriveTransformation.transientExpressionColumns,
            deriveTransformation
        );
        const partition = TransformationAdapter.getPartitionDslScript(deriveTransformation);

        const knownProps = `${columnConditions}${transientAssignments ? ',\n\t\t' : ''}${transientAssignments}${
            columnConditions && partition ? ',\n\t' : ''
        }${partition}`;
        const unknownProps = this._getUnknownProps(deriveTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(deriveTransformation)} ${
                DeriveTransformation.MODEL.name
            }(${transformationData}) ` + `${FLOW} ${this._getOutputStreams(deriveTransformation)}`
        );
    }
}
